/**
 * variant-card-ui.js — v1 (select + qty)
 * - Aggiorna il prezzo della card al change del select (con compare_at se presente)
 * - Gestisce stepper quantità (+ / -)
 * - ATC diretto usa la variante selezionata e la quantità scelta
 * - Safe: niente observer, normalizza al load e su eventi Shopify se presenti
 */
(function(){
  'use strict';

  const MONEY_FMT = window.__moneyFormat;

  function fmt(cents){
    const n = Number(cents || 0);
    try{
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(n, MONEY_FMT);
    }catch(e){}
    return '€' + (n/100).toFixed(2).replace('.',',');
  }

  function renderPrice(container, priceCents, compareCents){
  if (!container) return;
  const price   = Number(priceCents || 0);
  const compare = Number(compareCents || 0);
  const onSale  = compare > price;

  const html = onSale
    ? `<div class="price price--card price--on-sale">
         <div class="price__sale">
           <span class="visually-hidden visually-hidden--inline">Prezzo regolare</span>
           <s class="price-item price-item--regular">${fmt(compare)}</s>
           <span class="price-item price-item--sale price-item--last">${fmt(price)}</span>
         </div>
       </div>`
    : `<div class="price price--card">
         <div class="price__regular">
           <span class="visually-hidden visually-hidden--inline">Prezzo</span>
           <span class="price-item price-item--regular price-item--last">${fmt(price)}</span>
         </div>
       </div>`;

  container.innerHTML = html;
}

  function findPriceWrapper(fromEl){
    if (!fromEl) return null;
    // cerca un wrapper prezzo vicino
    const content = fromEl.closest('.card__content');
    if (content){
      const w = content.querySelector('[data-price-wrapper]');
      if (w) return w;
    }
    // fallback: fratello precedente
    const prev = fromEl.previousElementSibling;
    if (prev && prev.hasAttribute && prev.hasAttribute('data-price-wrapper')) return prev;
    return null;
  }

  function normalizeCard(ui){
    try{
      // trova select/hidden con data-role=variant-select
      const sel = ui.querySelector('[data-role="variant-select"], select.variant-select');
      if (!sel) return;

      // leggi variant + prezzi
      let variantId, price, compare, disabled = false;
      if (sel.tagName === 'SELECT'){
        const opt = sel.selectedOptions[0];
        variantId = opt ? opt.value : '';
        price   = opt ? (opt.getAttribute('data-price')   || opt.dataset.price   || '0') : '0';
        compare = opt ? (opt.getAttribute('data-compare') || opt.dataset.compare || '0') : '0';
// Fallback: se la variante non ha compare_at_price, usa quello di prodotto
if (!Number(compare)) {
  compare = sel.getAttribute('data-compare-fallback') || '0';
}
        disabled = opt ? opt.disabled : false;
      } else {
        variantId = sel.value || '';
        price   = sel.getAttribute('data-price')   || '0';
        compare = sel.getAttribute('data-compare') || '0';
      }

      // aggiorna prezzo
      renderPrice(findPriceWrapper(ui), price, compare);

      // sync ATC + abilita/disabilita
      const atc = ui.querySelector('.pill-atc') || ui.parentElement.querySelector('.pill-atc');
      if (atc){
        atc.dataset.variantId = variantId;
        atc.disabled = disabled || !variantId;
      }
    }catch(_e){}
  }

  function normalizeAll(){
    document.querySelectorAll('.card-variant-ui').forEach(normalizeCard);
  }

  // Change sul select delle varianti
  document.addEventListener('change', function(e){
    const sel = e.target.closest('select[data-role="variant-select"], select.variant-select');
    if (!sel) return;
    const ui = sel.closest('.card-variant-ui');
    if (!ui) return;
    normalizeCard(ui);
  });

  // Stepper quantità
  document.addEventListener('click', function(e){
    const dec = e.target.closest('[data-qty-dec]');
    const inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;

    const ui = (dec || inc).closest('.card-variant-ui');
    if (!ui) return;
    const input = ui.querySelector('.qty-input');
    if (!input) return;

    const min = Number(input.min || 1);
    const step = Number(input.step || 1);
    let val = parseInt(input.value, 10); if (isNaN(val)) val = min;

    if (dec) val = Math.max(min, val - step);
    if (inc) val = val + step;

    input.value = val;
  });

  // ATC diretto: usa variante selezionata + quantità stepper
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.pill-atc');
    if (!btn) return;
    e.preventDefault();

    const ui = btn.closest('.card__content')?.querySelector('.card-variant-ui') || null;
    // variante
    const variantId = Number(btn.dataset.variantId || 0);
    if (!variantId) return;

    // quantità
    let qty = 1;
    if (ui){
      const q = ui.querySelector('.qty-input');
      if (q){
        const val = parseInt(q.value, 10);
        qty = !isNaN(val) && val > 0 ? val : 1;
      }
    }

    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(r => r.ok ? r.json() : Promise.reject())
    .then(() => {
      btn.classList.remove('is-loading');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:open'));
      if (window.Scoutsidecart && typeof window.Scoutsidecart.open === 'function') window.Scoutsidecart.open();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    })
    .catch(() => {
      btn.classList.remove('is-loading');
      window.location.href = '/cart';
    });
  });

  // Prima normalizzazione
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', normalizeAll);
  } else {
    normalizeAll();
  }
  // Sezioni Shopify (quando ricarica la griglia)
  document.addEventListener('shopify:section:load', normalizeAll);
  document.addEventListener('shopify:section:reorder', normalizeAll);
})();
